<template>
  <v-container fluid>
    <v-data-table
      class="pt-3"
      flat
      style="width:auto"
      :loading="loading ? '#0482fb' : null"
      :headers="headers"
      :items="inventory"
      :items-per-page="5"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des déclarations sinistres </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-switch
            v-model="showAllFil"
            label="Afficher toutes les données"
            color="#0482fb"
            @change="showAllFillData"
            class="pt-5"
          ></v-switch>
          <v-spacer></v-spacer>

          <!--  Déclaration sinistre-->
          <template>
            <div>
              <v-row justify="center">
                <v-dialog
                  v-model="sinisterDialog"
                  overlay
                  width="500px"
                  transition="dialog-bottom-transition"
                  scrollable
                >
                  <v-card style="border-top:10px solid #0482fb">
                    <v-card-text>
                      <h2 class="pt-8 pl-3">Modification inventaire</h2>
                      <v-container fluid>
                        <v-row align="center">
                          <!-- <v-col cols="12" sm="3">
                      <v-text-field outlined  
            color="#0482fb"
                        v-model="sinisterAskNumber"
                        label="Numéro sinistre DAYO"
                      ></v-text-field>
                    </v-col> -->

                          <v-col cols="12" sm="12">
                            <v-select
                              outlined
                              :items="offreStatut"
                              v-model="offerModal.status"
                              label="Statut"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              outlined
                              v-model="offerModal.observation"
                              name="input-7-4"
                              label="Observation"
                              value=""
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="white--text ma-2"
                        color="error darken-1"
                        text
                        @click="sinisterDialog = false"
                      >
                        Retour
                      </v-btn>
                      <v-btn
                        class="white--text ma-2"
                        color="success "
                        @click="saveDeclaration"
                      >
                        Enregistrer
                      </v-btn>
                    </v-card-actions>

                    <div style="flex: 1 1 auto"></div>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
          </template>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Etes vous sûrs de vouloire supprimer cet élément
                ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text ma-2"
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn
                  class="white--text ma-2"
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Numéro sinistre DAYO..."
                      class="pt-5 pa-2"
                      v-model="sinisterAskNumber"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Numéro sinistre compagnie..."
                      class="pt-5 pa-2"
                      v-model="sinisterCompanyNumber"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Nom / Raison sociale assurer"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="fileName"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Nom / Raison sociale victime"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="victimName"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      outlined
                      :items="companyNameList"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="company"
                      flat
                      background-color="grey lighten-4"
                      label="Compagnie..."
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      outlined
                      :items="productNameList"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="product"
                      flat
                      background-color="grey lighten-4"
                      label="Produit"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date survenance debut ..."
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      type="date"
                      v-model="occurrenceStartDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date survenance fin..."
                      class="pt-5 pa-2"
                      type="date"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="occurrenceEndDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date déclaration debut ..."
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      type="date"
                      v-model="declarationStartDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date déclaration fin..."
                      class="pt-5 pa-2"
                      type="date"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="declarationEndDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date règlement debut ..."
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      type="date"
                      v-model="offerSendStartDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date règlement fin..."
                      class="pt-5 pa-2"
                      type="date"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="offerSendEndDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date réception chèque debut ..."
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      type="date"
                      v-model="checkReceiptStartDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Date réception chèque fin..."
                      class="pt-5 pa-2"
                      type="date"
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="checkReceiptEndDate"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text mr-2"
                    color="#0482fb"
                    pill
                    @click="onEnter"
                  >
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon color="warning" class="mr-2" @click="selectVictim(item)">
          mdi-pencil-box-multiple-outline
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { manageOffer } from "@/api/user.js";
export default {
  name: "production",
  components: {},
  data: () => ({
    dialog: false,
    companyNameList: [],
    productNameList: [],
    sinisterDialog: false,
    dialogDelete: false,
    fileName: "",
    product: "",
    offerModal: {},
    sinisterAskNumber: "",
    startDate: "",
    endDate: "",
    company: "",
    offreStatut: ["Suspens", "Soldé", "Sans suite", "Recours", "Prescrit"],

    loading: false,
    headers: [
      { text: "Actions", width: "100px", align: "left", value: "actions" },
      {
        text: "N° sinistre DAYO",
        align: "start",
        sortable: false,
        width: "200px",
        value: "sinisterAskNumber",
      },
      {
        text: "N° sinistre compagnie",
        width: "200px",
        value: "sinisterCompanyNumber",
      },
      { text: "Nom client", width: "200px", value: "contractName" },
      { text: "N° police", width: "200px", value: "contractPoliceNumber" },
      { text: "Nom victime", width: "200px", value: "thirdName" },
      { text: "Produit", width: "200px", value: "contractProduct" },
      { text: "Catégorie", width: "200px", value: "category" },
      { text: "Date suvenance", width: "200px", value: "dateOfOccurrenceFr" },
      { text: "Date déclaration", width: "200px", value: "declarationDateFr" },
      { text: "Compagnie", width: "200px", value: "contractCompany" },
      { text: "Circonstance", width: "200px", value: "circumstance" },
      //  { text: "Pièce à fournir", value: "stringDocumentsProvides" },
      //  { text: "Pièce fournies", value: "stringDocumentProvides" },
      //  { text: "Pièce Restantes", value: "stringNotDocumentsProvides" },
      { text: "Date demande PV", width: "200px", value: "requestDatePvFr" },
      { text: "Date réception PV", width: "200px", value: "receptionDatePvFr" },
      { text: "Nom commissariat", width: "200px", value: "policeStation" },
      {
        text: "Date demande BON",
        width: "200px",
        value: "couponRequestDateFr",
      },
      {
        text: "Date réception BON",
        width: "200px",
        value: "couponReceptionDateFr",
      },
      {
        text: "Date demande expertise",
        width: "200px",
        value: "dateRequestExpertiseFr",
      },
      {
        text: "Date réception Rapport",
        width: "200px",
        value: "expertiseReportReceptionDateFr",
      },
      { text: "Nom expert", width: "200px", value: "expertiseExpertName" },
      {
        text: "Dommages Matériels victime",
        width: "250px",
        value: "thirdPartyMaterialDamage",
      },
      {
        text: "Dommages Corporels victime",
        width: "250px",
        value: "thirdPartyBodilyInjury",
      },
      { text: "PSAP", width: "200px", value: "offerPSAP" },
      { text: "Montant offre", width: "200px", value: "offerAmount" },
      {
        text: "Date envoi pièces",
        width: "200px",
        value: "offerDocumentSendDateFr",
      },
      {
        text: "Date réception offre",
        width: "200px",
        value: "offerReceptDateFr",
      },
      {
        text: "Date réception accord",
        width: "200px",
        value: "offerAggreementReceptDateFr",
      },
      {
        text: "Date transmission accord",
        width: "200px",
        value: "offerAgreementTransmissionDateFr",
      },
      { text: "Statut", width: "200px", value: "offerStatus" },
      { text: "Obsservations", width: "200px", value: "offerObservation" },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    declarationModal: {},
  }),

  computed: {
    ...mapGetters(["inventory", "Companies", "Products"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getInventory",
      "getInventorySearch",
      "getProducts",
      "getCompanies",
    ]),
    showAllFillData() {
      this.initialize();
      //alert(this.showAllFil);
    },
    async makeSearchContract() {
      this.loading = true;
      //alert("ok");
      try {
        await this.getInventorySearch({
          sinisterCompanyNumber: this.sinisterCompanyNumber,
          sinisterAskNumber: this.sinisterAskNumber,
          declarationStartDate: this.declarationStartDate,
          declarationEndDate: this.declarationEndDate,
          occurrenceStartDate: this.occurrenceStartDate,
          occurrenceEndDate: this.occurrenceEndDate,
          fileName: this.fileName,
          victimName: this.victimName,
          company: this.company,
          product: this.product,
          offerSendStartDate: this.offerSendStartDate,
          offerSendEndDate: this.offerSendEndDate,
          checkReceiptStartDate: this.checkReceiptStartDate,
          checkReceiptEndDate: this.checkReceiptEndDate,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les sinistres")
        );
      }
      this.loading = false;
    },
    onEnter: function() {
      this.makeSearchContract();
    },
    async initialize() {
      this.loading = true;
      try {
        await this.getInventory({ withoutPeriod: this.showAllFil });
        await this.getCompanies();
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.declarationModal = Object.assign({}, this.declarationModal);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.declarationModal);
        this.editedIndex = -1;
      });
    },
    selectVictim(item) {
      this.editedIndex = 1;
      this.victimModal = Object.assign({}, item);

      this.offerModal.id = item._id ?  item._id : "";
      this.offerModal.status = item.offerStatus ? item.offerStatus :"";
      this.offerModal.observation = item.offerObservation ? item.offerObservation :"";

      // this.documentsProvides = item.otherInfo.documentsProvides ?? [];

      this.sinisterDialog = true;
    },
    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          status: this.offerModal.status,
          observation: this.offerModal.observation,
        };

        // add
        await manageOffer({
          schema,
          id: this.offerModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("offre")
        );
        this.closeDeclaration();
        this.initialize();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.declarationModal = {};
      this.sinisterDialog = false;
      // this.currentProduct = null;
    },
  },
};
</script>

<style scoped></style>
